import React, { useEffect, useRef, useState } from "react";

// Import ./BusBookingForm.css'Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import "./HotelSearchNew.css";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Container, Row, Col, Card, Form, Spinner } from "react-bootstrap";
import { BsArrowLeftRight } from "react-icons/bs";
// import FlightDeal from "../../../components/MainHome/Home/innerComponents/FlightDeal";
import { MdFlight, MdOutlineFlight } from "react-icons/md";
import { FaCity, FaHotel, FaSuitcaseRolling, FaWallet } from "react-icons/fa";
import moment from "moment";
import { BiSolidOffer } from "react-icons/bi";
import { IoBagHandleOutline } from "react-icons/io5";
import { BiSupport } from "react-icons/bi";
import Slider from "react-slick";
// import "./gdvfdty.css";
import { DayPickerRangeController } from "react-dates";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
// import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
// import { CountriesArray } from "../FlightSearchMobile/Countries";
// import { cities2 } from "./Cities";

import axios from "axios";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { IoIosArrowDropdownCircle } from "react-icons/io";
import { AiOutlineSwap } from "react-icons/ai";
import {
  services,
  nationalityOptions,
} from "../../Hotel/HotelSearch/HotelSearchData";
import WebOffer from "../../Home/Home/WebOffer";
import ReasonsToBook from "../../Home/Home/ReasonToBook";
import PopularDestinations from "../../Hotel/HotelSearch/HotelSearchMobile/PopularDestinations";
import HotelsContainer from "../../Hotel/HotelSearch/HotelComponent";
import Foot from "../../Footer/Foot";
import WhyUss from "../../Home/Home/WhyUss";
import AboutHome from "../../Home/Home/AboutHome";
import WhyBookUsNew from "../../Home/Home/WhyBookUsNew";
import HotelChains from "./HotelChains";
import MobileApp from "../../Flight/FlightSearchMobile/MobileApp";
import SectionsHotel from "../../Hotel/HotelSearch/SectionsHotel";
import { toast } from "react-toastify";
import RecentHotelSearch from "./RecentSearch";

// import { useDispatch } from "react-redux";
// import { flightSearch } from "../../../redux/services/operations/flight";

export const data = [
  {
    img: "https://fastui.cltpstatic.com/image/upload/f_auto,q_auto,w_260,h_204,dpr_2/offermgmt/images/banner/RR_Hifive_0712.png",
  },
  {
    img: "https://fastui.cltpstatic.com/image/upload/f_auto,q_auto,w_260,h_205,dpr_2/offermgmt/images/BBD/CTINT_RR_FLIGHTS_29052023.png",
  },
  {
    img: "https://fastui.cltpstatic.com/image/upload/f_auto,q_auto,w_260,h_205,dpr_2/offermgmt/images/BBD/GiftCards_RR_12072023.png",
  },
  {
    img: "https://fastui.cltpstatic.com/image/upload/f_auto,q_auto,w_260,h_205,dpr_2/offermgmt/images/banner/RR_LMD_H_3001.jpg",
  },
];

export var settings = {
  dots: false,
  autoplay: true,
  autoplaySpeed: 1500,
  infinite: true,
  speed: 100,
  slidesToShow: 1,
  slidesToScroll: 1,
};

export const extractBracketValue = (str) => {
  const regex = /\(([^)]+)\)/;
  const match = regex.exec(str);
  return match ? match[1] : null;
};
const cityToAirportCode = {
  Dubai: "DXB",
  Delhi: "DEL",
  Mumbai: "BOM",
  "New York": "JFK",
  London: "LHR",
  Paris: "CDG",
  Singapore: "SIN",
  // Add more cities as needed
};

// hotelCache.js
const HOTEL_CACHE_NAME = "hotel-search-cache";
const HOTEL_CACHE_DURATION = 30 * 24 * 60 * 60 * 1000; // 1 month

export const insertHotelSearchIntoCache = async (hotelData) => {
  const cache = await caches.open(HOTEL_CACHE_NAME);

  const timestampedData = { ...hotelData, timestamp: Date.now() };

  const response = new Response(JSON.stringify(timestampedData), {
    headers: { "Content-Type": "application/json" },
  });

  // Unique key: City-startDate-endDate-timestamp
  const cacheKey = `${hotelData.city}-${hotelData.startDate}-${hotelData.endDate}-${timestampedData.timestamp}`;

  await cache.put(new Request(cacheKey), response);

  // Enforce max 8 entries
  const keys = await cache.keys();
  if (keys.length > 8) {
    const keyDataPairs = await Promise.all(
      keys.map(async (key) => {
        const res = await cache.match(key);
        const data = await res.json();
        return { key, timestamp: data.timestamp };
      })
    );

    keyDataPairs.sort((a, b) => a.timestamp - b.timestamp);

    const keysToDelete = keyDataPairs.slice(0, keys.length - 8);
    for (let { key } of keysToDelete) {
      await cache.delete(key);
    }
  }
};

export const fetchValidHotelSearchesFromCache = async () => {
  const cache = await caches.open(HOTEL_CACHE_NAME);
  const keys = await cache.keys();

  const validSearches = [];

  for (let key of keys) {
    const res = await cache.match(key);
    const data = await res.json();

    if (Date.now() - data.timestamp < HOTEL_CACHE_DURATION) {
      validSearches.push(data);
    } else {
      await cache.delete(key);
    }
  }

  return validSearches.sort((a, b) => b.timestamp - a.timestamp).slice(0, 8);
};

const HotelSearchNew = () => {
  const bookusdata = [
    {
      img: "/Images/Icons/esy-flights.svg",
      head: "Easy Booking",
      desc: " Book Flights Easily and Grab Exciting Offers!",
    },
    {
      img: "/Images/Icons/down-arrows.svg",
      head: "Lowest Price",
      desc: "Guaranteed Low Rates on Hotels, Holiday Packages, and Flights",
    },
    {
      img: "/Images/Icons/return-boxs.svg",
      head: "Instant Refund",
      desc: "Get Quick and Easy Refunds on All Your Travel Bookings!",
    },
    {
      img: "/Images/Icons/24-hoursa.svg",
      head: "24/7 Support",
      desc: "24/7 Support for All Your Travel Queries — We're Here to Help!",
    },
    {
      img: "/Images/Icons/hot-sales.svg",
      head: "Exciting Deals",
      desc: "Unlock Exciting Deals on Flights, Hotels, Buses, Car Rentals, and Tours!",
    },
  ];
  const [rooms, setRooms] = useState([
    { adults: 2, children: 0, childrenAges: [] },
  ]);
  const [labelClicked, setLabelClicked] = useState(false);
  const [numberOfMonths, setNumberOfMonths] = useState(2);
  const [daysize, setDaySize] = useState(2);
  const [startDate, setStartDate] = useState(moment()); // today
  // const [startDate, setStartDate] = useState(moment().add(1, "days"));
  const [endDate, setEndDate] = useState(moment().add(1, "days")); // tomorrow
  const [searchedHotel, setSearchedHotel] = useState("New Delhi");
  // const [searchedHotel, setSearchedHotel] = useState(
  //   "NATIONAL CAPITAL TERRITORY OF DELHI,"
  // );
  // useEffect(() => {
  //   setEndDate(active2 ? moment().add(2, "days") : null);
  // }, [active2]);
  const [focusedInput, setFocusedInput] = useState(null);
  const [calVisible, setCalVisible] = useState(false);
  const [clickDestination, SetClickDestination] = useState(false);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    from: "",
  });

  useEffect(() => {
    const handleResize = () => {
      setBreakpoints();
    };
    window.addEventListener("resize", handleResize);
    setBreakpoints();
    return () => window.removeEventListener("resize", handleResize);
  });

  const setBreakpoints = () => {
    const isSmallScreen = window.innerWidth <= 768;
    const isMediumScreen = window.innerWidth > 768 && window.innerWidth <= 992;
    if (isSmallScreen) {
      setDateRangeConfig(1, 30, 30);
    } else if (isMediumScreen) {
      setDateRangeConfig(2, 30, 60);
    } else {
      setDateRangeConfig(2, 40, 50);
    }
  };

  const setDateRangeConfig = (numberOfMonths, daysize) => {
    setNumberOfMonths(numberOfMonths);
    setDaySize(daysize);
  };

  const addRoom = () => {
    if (rooms.length < 6) {
      setRooms([...rooms, { adults: 2, children: 0, childrenAges: [] }]);
    }
  };

  const removeRoom = (index) => {
    if (rooms.length > 1) {
      const updatedRooms = [...rooms];
      updatedRooms.splice(index, 1);
      setRooms(updatedRooms);
    }
  };

  const updateRoom = (index, field, value) => {
    const updatedRooms = [...rooms];
    updatedRooms[index][field] = value;
    if (field === "children") {
      updatedRooms[index].childrenAges = Array(value).fill(null); // Reset children ages
    }
    setRooms(updatedRooms);
  };

  const updateChildAge = (roomIndex, childIndex, age) => {
    const updatedRooms = [...rooms];
    updatedRooms[roomIndex].childrenAges[childIndex] = age;
    setRooms(updatedRooms);
  };

  const handleDatesChange = ({ startDate, endDate }) => {
    setStartDate(startDate);
    setEndDate(endDate);
    if (startDate && endDate) {
      setFocusedInput(null);
      setCalVisible(false);
    } else if (startDate) {
      setFocusedInput("endDate");
    }
  };

  const toggleCalendar = (input) => {
    setCalVisible(!calVisible);
    if (!calVisible) {
      if (input === "startDate") {
        setFocusedInput("startDate");
      } else if (input === "endDate") {
        setFocusedInput("endDate");
      } else {
        setCalVisible(!calVisible);
        if (!calVisible) setFocusedInput("startDate");
        else setFocusedInput(null);
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const [cacheData, setCacheData] = useState("");
  useEffect(() => {
    const data = async () => {
      const cachedSearches = await fetchValidHotelSearchesFromCache();
      if (cachedSearches) {
        setCacheData(cachedSearches);
      }
    };
    data();
  }, []);
  console.log("cache data", cacheData);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!startDate || !endDate) {
      toast.error(`Please fill out all fields ${startDate} ${endDate}`);
      return;
    }

    const formDataToPass = {
      ...formData,
      from: selectedCityId,
      city: selectedCityName,
      startDate: startDate.format("YYYY-MM-DD"),
      endDate: endDate.format("YYYY-MM-DD"),
      rooms: JSON.stringify(rooms), 
    };

    console.log("form data filled", {
      ...formData,
      from: selectedCityId,
      city: selectedCityName,
      startDate: startDate.format("YYYY-MM-DD"),
      endDate: endDate.format("YYYY-MM-DD"),
      rooms: rooms,
    });

    // store user config in localStorage
    localStorage.setItem("hotelRoomsConfig", JSON.stringify(rooms));
    localStorage.setItem("hotelCin", startDate.format("YYYY-MM-DD"));
    localStorage.setItem("hotelCout", endDate.format("YYYY-MM-DD"));

    // ⭐ INSERT INTO CACHE (same pattern as your flight code)
    await insertHotelSearchIntoCache({
      ...formDataToPass,
      cityName: selectedCityId || "",

      rooms: rooms, // store rooms as array
    });

    const queryString = new URLSearchParams(formDataToPass).toString();
    navigate(`/hotelmodify?${queryString}`);
  };

  const topCities = [
    {
      id: 130443,
      CityName: "New Delhi",
      CountryName: "India",
      CountryCode: "IN",
      isTopCity: true,
      category: "domestic",
    },
    {
      id: 144306,
      CityName: "Mumbai",
      CountryName: "India",
      CountryCode: "IN",
      isTopCity: true,
      category: "domestic",
    },
    {
      id: 111124,
      CityName: "Bangalore",
      CountryName: "India",
      CountryCode: "IN",
      isTopCity: true,
      category: "domestic",
    },
    {
      id: 133133,
      CityName: "Pune",
      CountryName: "India",
      CountryCode: "IN",
      isTopCity: true,
      category: "domestic",
    },
    {
      id: 100263,
      CityName: "Ahmedabad",
      CountryName: "India",
      CountryCode: "IN",
      isTopCity: true,
      category: "domestic",
    },
    {
      id: 122175,
      CityName: "Jaipur",
      CountryName: "India",
      CountryCode: "IN",
      isTopCity: true,
      category: "domestic",
    },
    {
      id: 100589,
      CityName: "Agra",
      CountryName: "India",
      CountryCode: "IN",
      isTopCity: true,
      category: "domestic",
    },
    {
      id: 145710,
      CityName: "Hyderabad",
      CountryName: "India",
      CountryCode: "IN",
      isTopCity: true,
      category: "domestic",
    },
    {
      id: 115936,
      CityName: "Dubai",
      CountryName: "United Arab Emirates",
      CountryCode: "AE",
      isTopCity: true,
      category: "international",
    },
    {
      id: 100765,
      CityName: "Abu Dhabi",
      CountryName: "United Arab Emirates",
      CountryCode: "AE",
      isTopCity: true,
      category: "international",
    },
    {
      id: 138703,
      CityName: "Singapore",
      CountryName: "Singapore",
      CountryCode: "SG",
      isTopCity: true,
      category: "international",
    },
    {
      id: 144092,
      CityName: "Bangkok",
      CountryName: "Thailand",
      CountryCode: "TH",
      isTopCity: true,
      category: "international",
    },
  ];

  const filterAndRankCities = (cities, value) => {
    const v = (value || "").toLowerCase();
    if (!v) return [];
    return cities
      .filter((city) => {
        return (
          city &&
          ((city.CityName && String(city.CityName).toLowerCase().includes(v)) ||
            (city.CountryName &&
              String(city.CountryName).toLowerCase().includes(v)) ||
            (city.StateProvince &&
              String(city.StateProvince).toLowerCase().includes(v)) ||
            (city.DestinationId &&
              String(city.DestinationId).toLowerCase().includes(v)))
        );
      })
      .map((city) => {
        let priority = 3;
        if (city.CityName && String(city.CityName).toLowerCase().includes(v)) {
          priority = 1;
        } else if (
          city.CountryName &&
          String(city.CountryName).toLowerCase().includes(v)
        ) {
          priority = 2;
        } else if (
          city.StateProvince &&
          String(city.StateProvince).toLowerCase().includes(v)
        ) {
          priority = 3;
        }
        return { ...city, priority };
      })
      .sort((a, b) => a.priority - b.priority)
      .slice(0, 20);
  };

  const mergeResults = (staticResults, apiResults) => {
    const out = [];
    const seen = new Set();
    const keyFor = (item) => {
      const id = String(item.DestinationId || item.id || "").trim();
      if (id) return `id:${id}`;
      const cn = String(item.CityName || "")
        .trim()
        .toLowerCase();
      const co = String(item.CountryName || "")
        .trim()
        .toLowerCase();
      return `name:${cn}|${co}`;
    };
    for (const s of staticResults) {
      const k = keyFor(s);
      if (!seen.has(k)) {
        seen.add(k);
        out.push(s);
      }
    }
    for (const a of apiResults) {
      const k = keyFor(a);
      if (!seen.has(k)) {
        seen.add(k);
        out.push(a);
      }
    }
    return out.slice(0, 20);
  };

  const handleInputChange = async (value) => {
    setSearchInput(value.toLowerCase());
    SetClickDestination(true);
    setIsItemSelected(false);

    if (value.length === 0) {
      // Show top cities when input is empty
      setCities2(topCities);
      setIsApiLoading(false);
    } else if (value.length >= 3) {
      const v = value.toLowerCase();
      const staticResults = filterAndRankCities(staticHotelCities, v);
      latestQueryRef.current = v;
      if (staticResults.length > 0) {
        setCities2(staticResults);
      } else {
        setCities2([]);
      }
      setIsApiLoading(true);
      try {
        const apiResults = await fetchDatas(v);
        if (latestQueryRef.current !== v) return;
        const merged =
          staticResults.length > 0
            ? mergeResults(staticResults, apiResults)
            : apiResults;
        setCities2(merged);
      } finally {
        if (latestQueryRef.current === v) setIsApiLoading(false);
      }
    } else {
      setCities2([]); // clear suggestions if less than 3 characters
      setIsApiLoading(false);
    }
  };

  const handleInputFocus = () => {
    setSearchInput("");
    setSearchedHotel("");
    SetClickDestination(true);
    setCities2(topCities);
  };

  const handleInputBlur = () => {
    if (!isItemSelected && searchInput === "") {
      setSearchInput("New Delhi");
    }
  };

  const [searchInput, setSearchInput] = useState("New Delhi (India)");
  const [isItemSelected, setIsItemSelected] = useState(true);
  const [cities2, setCities2] = useState([]);
  const [staticHotelCities, setStaticHotelCities] = useState([]);
  const [isApiLoading, setIsApiLoading] = useState(false);
  const [destinationCity, setDestinationCity] = useState("New Delhi");
  const [selectedCityId, setSelectedCityId] = useState(130443);
  const [destination1, setDestination1] = useState({
    id: 130443,
    CityName: "New Delhi",
    CountryName: "India",
    CountryCode: "IN",
    isTopCity: true,
    category: "domestic",
  });
  const [selectedCityName, setSelectedCityName] = useState("New Delhi");

  const inputContainerRef = useRef(null);
  const latestQueryRef = useRef("");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        inputContainerRef.current &&
        !inputContainerRef.current.contains(event.target)
      ) {
        SetClickDestination(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const loadStaticHotelCities = async () => {
      try {
        const response = await fetch(
          `${process.env.PUBLIC_URL || ""}/HotelCities.js`,
          { cache: "no-store" }
        );
        const scriptText = await response.text();
        const transformed = scriptText
          .replace(/^[\s\S]*?export\s+const\s+hotelCities\s*=\s*/m, "return ")
          .replace(/;\s*$/, ";");
        const parser = new Function(transformed);
        const cities = parser();
        if (Array.isArray(cities)) {
          setStaticHotelCities(cities);
        }
      } catch (e) {}
    };
    loadStaticHotelCities();
  }, []);

  const handleCitySelect = (city) => {
    setDestinationCity(`${city["CityName"]}`);
    setSelectedCityId(`${city["id"] || city["DestinationId"] || ""}`);
    setSelectedCityName(city["CityName"]);
    setSearchedHotel(`${city["CityName"]}`);
    SetClickDestination(false);
    setSearchInput(`${city["CityName"]} (${city["CountryName"]})`);
    setIsItemSelected(true);
    setDestination1(city);
  };

  const fetchDatas = async (value) => {
    try {
      const requestData = {
        city: value,
      };

      const response = await axios.post(
        "https://admin.travelsdata.com/api/Hotel/CityList",
        requestData
      );

      const json = response.data;
      console.log("json responseee", json);

      const results = json.data
        .filter((user) => {
          return (
            user &&
            ((user.CityName &&
              user.CityName.toLowerCase().includes(value.toLowerCase())) ||
              (user.CountryName &&
                user.CountryName.toLowerCase().includes(value.toLowerCase())))
          );
        })
        .map((user) => {
          let priority = 3;

          if (
            user.CityName &&
            user.CityName.toLowerCase().includes(value.toLowerCase())
          ) {
            priority = 1;
          } else if (
            user.CountryName &&
            user.CountryName.toLowerCase().includes(value.toLowerCase())
          ) {
            priority = 2;
          }

          return { ...user, priority };
        })
        .sort((a, b) => a.priority - b.priority)
        .slice(0, 20);

      console.log("RESULTS", results);
      return results;
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  };

  const slides = [
    {
      backgroundImage:
        "https://www.harbourhotels.co.uk/media/d4ipp450/1c57cb2a162815dd23ef3db35d0e8521.jpg",
      overlayColor: "#1d489f36",
      imgMark: "/Images/dream-feather-bg.png",
      title: "Search Hotels",
      subtitle: "Smooth Hotel Booking, Unbeatable Low Prices",
    },
    {
      backgroundImage:
        "https://3.imimg.com/data3/FM/MD/MY-1906485/hotel-booking.jpg",
      overlayColor: "#190a0a",
      imgMark: "/Images/dream-feather-bg.png",
      title: "Unlock Exclusive Hotel Deals",
      subtitle:
        "Premium Stays, Corporate Rates, and Seamless Hospitality Solutions",
    },
    {
      backgroundImage:
        "https://www.harbourhotels.co.uk/media/d4ipp450/1c57cb2a162815dd23ef3db35d0e8521.jpg",
      overlayColor: "#190a0a",
      imgMark: "/Images/dream-feather-bg.png",
      title: "Experience Hassle-Free Hotel Bookings",
      subtitle: "Premium Stays, and Unmatched Service – Only on Innovate Blues",
    },
  ];

  return (
    <div
      className="bookimg_form_containerrr"
      // style={{
      //   background:
      //     "url('https://images.pexels.com/photos/30247232/pexels-photo-30247232/free-photo-of-airplane-wing-above-clouds-at-sunrise.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2')",
      //   backgroundSize: "cover",
      //   backgroundRepeat: "no-repeat",
      //   width: "100%",
      // }}
    >
      <div style={{ position: "relative" }}>
        <Swiper
          pagination={{
            dynamicBullets: true,
          }}
          autoplay={{
            delay: 50000,
            disableOnInteraction: false,
          }}
          modules={[Autoplay, Pagination]}
          className="mySwiper"
          style={{ height: "300px" }}
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={index}>
              <div
                className="backgroundBanner banner banner-image"
                style={{
                  backgroundImage: `url(${slide.backgroundImage})`,
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                }}
                data-v-0b3b4b19=""
                data-v-b9cf504c=""
              >
                <div
                  className="overlay"
                  style={{
                    backgroundColor: slide.overlayColor,
                    opacity: slide.overlayOpacity || "0.5",
                  }}
                ></div>

                {slide.imgMark && (
                  <img
                    src={slide.imgMark}
                    alt="img-mark"
                    className="img-mark"
                    data-v-0b3b4b19=""
                  />
                )}
                <h1 className="description" data-v-0b3b4b19="">
                  <div>{slide.title}</div>
                  <div>{slide.subtitle}</div>
                </h1>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <Container>
        <div className="flightWidgetSection appendBottom40">
          <div className="searchWidgetContainer">
            <form
              onSubmit={handleSubmit}
              data-cy="flightSW"
              className="fltWidgetSection appendBottom40 primaryTraveler "
            >
              <div className="makeFlex hrtlCenter">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                ></div>
              </div>
              <div className="fsw ">
                <div className="fsw_inner returnPersuasion">
                  <div
                    className="flt_fsw_inputBox searchCity inactiveWidget "
                    style={{ width: "475px" }}
                    ref={inputContainerRef}
                  >
                    <label htmlFor="fromCity">
                      <span className="lbl_input appendBottom10 ">
                        Enter City Name, Location, or Specific hotel
                      </span>
                      <input
                        data-cy="fromCity"
                        id="fromCity"
                        type="text"
                        className="fsw_inputField lineHeight36 latoBlack font30"
                        placeholder="Enter City/Hotel Name"
                        value={searchInput}
                        autoComplete="off"
                        onFocus={handleInputFocus}
                        onBlur={handleInputBlur}
                        onChange={(e) => handleInputChange(e.target.value)}
                      />

                      <p
                        className="code makeRelative"
                        title="DEL, Delhi Airport India"
                      >
                        <span
                          data-cy="defaultFromValue"
                          title=""
                          className="truncate airPortName "
                        >
                          {searchedHotel}
                        </span>
                      </p>
                    </label>
                    <div style={{ position: "relative" }}>
                      <div
                        className="cityselect"
                        style={{
                          position: "absolute",
                          color: "black",
                          backgroundColor: "white",
                          padding: "10px",
                          border: "1px solid #e3e3e3",
                          display: clickDestination ? "block" : "none",
                          width: "100%",
                          zIndex: 9,
                          top: "5px",
                          maxHeight: 300,
                          borderRadius: "5px",
                          overflow: "auto",
                          scrollbarWidth: "thin",
                          background: "#fff",
                          boxShadow: "0 0 3px rgb(0 0 0 / 30%)",
                        }}
                      >
                        <>
                          {cities2.length !== 0 ? (
                            <>
                              {cities2.filter((city) => !city.isTopCity)
                                .length === 0 && (
                                <div className="desktop_autosugg">
                                  <div className="desk_sugg_bx flx-clm marbtm0">
                                    <div className="rec_txt">
                                      Popular Search in Domestic
                                    </div>
                                    <div className="clr" />
                                    <div className="pop_city_bx">
                                      {topCities
                                        .filter(
                                          (city) => city.category === "domestic"
                                        )
                                        .map((city, index) => (
                                          <a
                                            key={index}
                                            onClick={() =>
                                              handleCitySelect(city)
                                            }
                                          >
                                            {city.CityName}
                                          </a>
                                        ))}
                                    </div>
                                    <div className="clr" />
                                    <div className="rec_txt">
                                      Popular Search in International
                                    </div>
                                    <div className="clr" />
                                    <div className="pop_city_bx">
                                      {topCities
                                        .filter(
                                          (city) =>
                                            city.category === "international"
                                        )
                                        .map((city, index) => (
                                          <a
                                            key={index}
                                            onClick={() =>
                                              handleCitySelect(city)
                                            }
                                          >
                                            {city.CityName}
                                          </a>
                                        ))}
                                    </div>
                                  </div>
                                </div>
                              )}

                              {cities2
                                .filter((city) => !city.isTopCity)
                                .slice(0, 20)
                                .map((city, index) => (
                                  <div
                                    key={index}
                                    style={{
                                      borderBottom: "1px solid grey",
                                      paddingBottom: 5,
                                      marginBottom: 5,
                                      cursor: "pointer",
                                      backgroundColor: "white",
                                    }}
                                    onClick={() => handleCitySelect(city)}
                                  >
                                    <Row>
                                      <Col
                                        md={1}
                                        style={{ alignItems: "center" }}
                                      >
                                        <FaCity
                                          size={22}
                                          style={{
                                            textAlign: "center",
                                            height: "100%",
                                            color: "#2d3290",
                                          }}
                                        />
                                      </Col>
                                      <Col md={11}>
                                        <Row>
                                          <div
                                            className="flightFromName"
                                            style={{
                                              color: "#2d3290",
                                              fontWeight: 600,
                                            }}
                                          >
                                            {city.CityName}
                                          </div>
                                        </Row>
                                        <Row style={{ color: "grey" }}>
                                          <Col
                                            md={10}
                                            style={{ paddingRight: 0 }}
                                          >
                                            <div
                                              className="flightFromNameInner"
                                              style={{
                                                fontSize: 10,
                                                fontWeight: 600,
                                              }}
                                            >
                                              {city.CountryName}
                                            </div>
                                          </Col>
                                          <Col
                                            md={2}
                                            style={{ paddingLeft: 0 }}
                                          >
                                            <div
                                              style={{
                                                textAlign: "center",
                                                fontWeight: "700",
                                                fontSize: 10,
                                              }}
                                            >
                                              {city.CountryCode}
                                            </div>
                                          </Col>
                                        </Row>
                                      </Col>
                                    </Row>
                                  </div>
                                ))}

                              {isApiLoading && (
                                <div
                                  style={{
                                    padding: "8px 5px",
                                    fontSize: "12px",
                                    textAlign: "center",
                                  }}
                                >
                                  <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                  />{" "}
                                  Loading more results...
                                </div>
                              )}
                            </>
                          ) : (
                            <div
                              style={{
                                padding: "10px 5px",
                                fontSize: "12px",
                                textAlign: "center",
                                margin: "auto",
                                width: "100%",
                              }}
                            >
                              {isApiLoading ? (
                                <>
                                  <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                  />{" "}
                                  Fetching city list...
                                </>
                              ) : (
                                <>No matching cities found</>
                              )}
                            </div>
                          )}
                        </>
                      </div>
                    </div>
                  </div>
                  <div className="flt_fsw_inputBox dates inactiveWidget ">
                    <label htmlFor="departure">
                      <span className="lbl_input appendBottom10">Check-In</span>
                      <input
                        data-cy="departure"
                        id="departure"
                        type="text"
                        className="fsw_inputField font20"
                        defaultValue="Monday, 3 Jun 2024"
                        onChange={handleChange}
                        value={startDate ? startDate.format("MM/DD/YYYY") : ""}
                        readOnly
                        required
                        onClick={toggleCalendar}
                      />
                      <p
                        data-cy="departureDate"
                        className="blackText font20 code lineHeight36"
                      >
                        <span className="font30 latoBlack">
                          {startDate ? startDate.format("D") : "--"}{" "}
                        </span>
                        <span>
                          {startDate ? startDate.format("MMM") : "Month"}
                        </span>
                        <span className="shortYear">
                          {startDate ? startDate.format("YY") : ""}
                        </span>
                      </p>
                      <p data-cy="departureDay" className="code ">
                        {startDate ? startDate.format("dddd") : "Select a date"}
                      </p>
                    </label>
                    <div
                      style={{
                        position: "absolute",
                        zIndex: "2000",
                      }}
                    >
                      {calVisible && (
                        <DayPickerRangeController
                          startDate={startDate}
                          endDate={endDate}
                          onDatesChange={handleDatesChange}
                          focusedInput={focusedInput}
                          onFocusChange={(focused) => setFocusedInput(focused)}
                          isOutsideRange={(day) =>
                            day.isBefore(moment(), "day")
                          } // Disable days before today
                          // renderDayContents={renderDayContents}
                          numberOfMonths={numberOfMonths} // Allow selecting a range of dates when active2 is true
                          daySize={daysize}
                        />
                      )}
                    </div>
                  </div>
                  <div
                    className="flt_fsw_inputBox dates reDates inactiveWidget "
                    // style={{ opacity: active2 ? "1" : "0.3" }}
                  >
                    <div data-cy="returnArea">
                      <label
                        onChange={handleChange}
                        onClick={() => {
                          toggleCalendar("endDate");
                        }}
                        htmlFor="returnDate"
                      >
                        <span className="lbl_input appendBottom10">
                          Check-Out
                        </span>
                        <input
                          type="text"
                          id="returnDateInput"
                          name="returnDate"
                          className="fsw_inputField font20"
                          defaultValue="Monday, 3 Jun 2024"
                          onChange={handleChange}
                          value={endDate ? endDate.format("MM/DD/YYYY") : ""}
                          readOnly
                          onClick={() => {
                            toggleCalendar("endDate");
                          }}
                        />
                        <p
                          data-cy="departureDate"
                          className="blackText font20 code lineHeight36"
                          onClick={() => {
                            toggleCalendar("endDate");
                          }}
                        >
                          <span className="font30 latoBlack">
                            {endDate ? endDate.format("D") : "--"}{" "}
                          </span>
                          <span>
                            {endDate ? endDate.format("MMM") : "Month"}
                          </span>
                          <span className="shortYear">
                            {endDate ? endDate.format("YY") : ""}
                          </span>
                        </p>
                        <p data-cy="departureDay" className="code ">
                          {endDate ? endDate.format("dddd") : "Select a date"}
                        </p>
                      </label>
                    </div>
                  </div>
                  <div
                    data-cy="flightTraveller"
                    className="flt_fsw_inputBox flightTravllers inactiveWidget "
                  >
                    <label htmlFor="travellers">
                      <span className="lbl_input appendBottom5">
                        Rooms &amp; Guests
                      </span>
                      <input
                        type="text"
                        placeholder={`${rooms.reduce(
                          (total, room) => total + room.adults + room.children,
                          0
                        )} Persons in ${rooms.length} ${
                          rooms.length === 1 ? "Room" : "Rooms"
                        }`}
                        className="fsw_inputField font30 latoBlack"
                        readOnly=""
                        onClick={() => setLabelClicked(!labelClicked)}
                        defaultValue="0 Adult, 1 Children"
                      />
                      <p
                        onClick={() => setLabelClicked(!labelClicked)}
                        className="blackText font20 code lineHeight36"
                      >
                        <span className="appendRight10">
                          {`${rooms.reduce(
                            (total, room) =>
                              total + room.adults + room.children,
                            0
                          )} Guest, ${rooms.length} ${
                            rooms.length === 1 ? "Room" : "Rooms"
                          }`}
                          &nbsp;
                          {/* </span> */}
                        </span>
                      </p>
                    </label>
                    <div
                      className="onlytraveller normaltraveller"
                      style={{
                        display: labelClicked ? "block" : "none",
                      }}
                    >
                      <ul className="traveller_list">
                        <li>
                          <div
                            className="list-persons-count"
                            style={{ marginBottom: "8px" }}
                          >
                            <ul className="traveller_list">
                              {rooms.map((room, index) => (
                                <li>
                                  <div className="list-persons-count">
                                    <div id="roomshtml">
                                      <div
                                        className="box"
                                        key={`divroom${index + 1}`}
                                        id={`divroom${index + 1}`}
                                      >
                                        <div className="roomTxt">
                                          <span>Room {index + 1}:</span>
                                        </div>
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            marginTop: "10px",
                                          }}
                                        >
                                          <div className="">
                                            <div className="txt">
                                              <span id="Label7">Adult</span>
                                              <div style={{ fontSize: "10px" }}>
                                                <em>(12+ years)</em>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="right pull-right">
                                            <div
                                              id="field1"
                                              className="right PlusMinusRow"
                                            >
                                              <Link
                                                type="button"
                                                id="Adults_room_1_1_minus"
                                                className="sub hoteladultclass"
                                                onClick={() =>
                                                  updateRoom(
                                                    index,
                                                    "adults",
                                                    Math.max(room.adults - 1, 1)
                                                  )
                                                }
                                              >
                                                -
                                              </Link>
                                              <span
                                                id="Adults_room_1_1"
                                                className="PlusMinus_number"
                                              >
                                                {room.adults}
                                              </span>
                                              <Link
                                                type="button"
                                                id="Adults_room_1_1_plus"
                                                className="add hoteladultclass"
                                                onClick={() =>
                                                  updateRoom(
                                                    index,
                                                    "adults",
                                                    Math.min(room.adults + 1, 6)
                                                  )
                                                }
                                              >
                                                +
                                              </Link>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="spacer"></div>
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                          }}
                                        >
                                          <div className="">
                                            <span className="txt">
                                              <div id="Label9">
                                                Child <br />
                                                <div
                                                  style={{ fontSize: "10px" }}
                                                >
                                                  <em>(2-12 years)</em>
                                                </div>
                                              </div>
                                            </span>
                                          </div>
                                          <div className="right">
                                            <div
                                              id="field2"
                                              className="right PlusMinusRow"
                                            >
                                              <Link
                                                type="button"
                                                id="Children_room_1_1_minus"
                                                className="sub hotelchildclass"
                                                onClick={() =>
                                                  updateRoom(
                                                    index,
                                                    "children",
                                                    Math.max(
                                                      room.children - 1,
                                                      0
                                                    )
                                                  )
                                                }
                                              >
                                                -
                                              </Link>
                                              <span
                                                id="Children_room_1_1"
                                                className="PlusMinus_number"
                                              >
                                                {room.children}
                                              </span>
                                              <Link
                                                type="button"
                                                id="Children_room_1_1_plus"
                                                className="add hotelchildclassss"
                                                onClick={() =>
                                                  updateRoom(
                                                    index,
                                                    "children",
                                                    Math.min(
                                                      room.children + 1,
                                                      6
                                                    )
                                                  )
                                                }
                                              >
                                                +
                                              </Link>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="clear"></div>
                                        {room.children > 0 && (
                                          <div className="childresAgeTxt">
                                            Age(s) of Children
                                          </div>
                                        )}
                                        {room.childrenAges.map(
                                          (age, childIndex) => (
                                            <select
                                              key={childIndex}
                                              value={age || ""}
                                              onChange={(e) =>
                                                updateChildAge(
                                                  index,
                                                  childIndex,
                                                  e.target.value
                                                )
                                              }
                                            >
                                              <option value="">Age</option>
                                              {[...Array(12)].map(
                                                (age, index) => (
                                                  <option
                                                    key={index + 1}
                                                    value={age}
                                                  >
                                                    {index + 1}
                                                  </option>
                                                )
                                              )}
                                            </select>
                                          )
                                        )}
                                        <div className="clear"></div>
                                      </div>
                                    </div>

                                    <Link
                                      id="addhotelRoom"
                                      to="#"
                                      className="cus_add_remove_btn addroom"
                                      style={{
                                        display:
                                          index === rooms.length - 1
                                            ? "inline-block"
                                            : "none",
                                      }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        addRoom();
                                      }}
                                    >
                                      Add Room
                                    </Link>
                                    <Link
                                      id="removehotelRoom"
                                      to="#"
                                      className="cus_add_remove_btn removeroom"
                                      style={{
                                        display:
                                          rooms.length > 1
                                            ? "inline-block"
                                            : "none",
                                      }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        removeRoom(index);
                                      }}
                                    >
                                      Remove Room
                                    </Link>
                                  </div>
                                </li>
                              ))}
                            </ul>

                            <Link
                              className="apply_btn"
                              onClick={(e) => {
                                e.preventDefault();
                                setLabelClicked(false);
                              }}
                            >
                              Done
                            </Link>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="flt_fsw_inputBox dates reDates inactiveWidget search_flight_bookingsss ">
                    <div>
                      {" "}
                      <button className="mat-stroked-button" type="submit">
                        Search Hotel
                      </button>
                    </div>
                  </div>
                </div>
                {cacheData && cacheData.length !== 0 && (
                  <div
                    className={`makeFlex hrtlCenter flightFare`}
                    style={{ marginTop: "20px", padding: "0px 5px" }}
                  >
                    <div
                      className="ng-tns-c8-3 ng-star-inserted"
                      style={{
                        cursor: "pointer",
                        marginLeft: "19px",
                        marginTop: "-6px",
                        marginRight: "15px",
                      }}
                    >
                      <Link
                        className="active"
                        rel="noopener"
                        style={{ color: "#1d489f" }}
                        // onClick={handleClick}
                      >
                        <IoIosArrowDropdownCircle size={20} /> You’ve Searched
                      </Link>
                    </div>

                    <div className="specialFareContainer relative makeFlex centerContainer">
                      <div style={{ paddingLeft: "10px", color: "#333" }}>
                        <RecentHotelSearch cacheData={cacheData} />
                      </div>
                    </div>
                  </div>
                )}
                <div className="makeFlex hrtlCenter appendBottom20 flightFare"></div>
              </div>
            </form>
          </div>
        </div>
      </Container>
      <WebOffer />
      {/* <ReasonsToBook/> */}
      <HotelsContainer />
      <SectionsHotel />
      <WhyBookUsNew bookusdata={bookusdata} />
      {/* <MobileApp
        backgroundImage="https://jaanveertoursandtravels.com/assets/img/product/tour/hotel.jpg"
        title="Download Our Mobile App"
        description="Book the flight ticket and hotel with the huge discount. Refer friends and get generous bonuses from theirs orders."
      /> */}
      <HotelChains />
      <AboutHome />
    </div>
  );
};

export default HotelSearchNew;
